import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../../../DataService/apiClient";
import { MemberHistoryResponse } from "../../../Types/MemberHistoryTypes";
import "../MemberDashboard.css";

export const DashboardHistory = () => {
  const navigate = useNavigate();
  const [history, setHistory] = useState<MemberHistoryResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadHistory();
  }, []);

  const loadHistory = async () => {
    try {
      const res = await apiGet<MemberHistoryResponse>("/Auth/me/history");
      setHistory(res);
    } catch (err) {
      console.error("History load error", err);
    }
    setLoading(false);
  };

  if (loading) {
    return <div className="dashboard-section"><p>Laddar historik...</p></div>;
  }

  const orders = history?.orders ?? [];
  const purchases = history?.purchases ?? [];
  const bookings = history?.bookings ?? [];

  const getRotPaymentLabel = (stage?: string | null) => {
    if (!stage) return null;
    if (stage === 'registration') return 'ROT: registrerad';
    if (stage === 'balance') return 'ROT: fullt betald';
    return null;
  };

  return (
    <div className="dashboard-section">
      <div className="dashboard-header">
        <h1>Historik</h1>
        <p>Dina köp, bokningar och tidigare steg</p>
      </div>

      <div className="dashboard-summary-grid">
        <div className="dashboard-summary-card"><span>Order</span><strong>{orders.length}</strong></div>
        <div className="dashboard-summary-card"><span>Köp</span><strong>{purchases.length}</strong></div>
        <div className="dashboard-summary-card"><span>Bokningar</span><strong>{bookings.length}</strong></div>
      </div>

      <div className="dashboard-card">
        <h3>Senaste order</h3>
        {orders.length === 0 ? <p>Inga order ännu.</p> : (
          <div className="dashboard-history-list">
            {orders.slice(0, 5).map(order => (
              <div key={order.id} className="dashboard-history-item">
                <div>
                  <strong>{order.orderNumber}</strong>
                  <p>{order.items.map(item => item.title).join(", ")}</p>
                  {getRotPaymentLabel(order.items.find(item => item.programPaymentStage)?.programPaymentStage) && (
                    <p>{getRotPaymentLabel(order.items.find(item => item.programPaymentStage)?.programPaymentStage)}</p>
                  )}
                </div>
                <div className="dashboard-history-meta">
                  <span>{order.status}</span>
                  <strong>{order.totalAmount.toFixed(2)} SEK</strong>
                  <button className="dashboard-inline-btn" onClick={() => navigate(`/member/orders/${order.id}`)}>Visa</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="dashboard-card">
        <h3>Köp</h3>
        {purchases.length === 0 ? <p>Inga köp registrerade ännu.</p> : (
          <div className="dashboard-history-list">
            {purchases.slice(0, 8).map(purchase => (
              <div key={purchase.id} className="dashboard-history-item">
                <div>
                  <strong>{purchase.productType}</strong>
                  <p>{purchase.paymentReference}</p>
                </div>
                <div className="dashboard-history-meta">
                  <span>{purchase.status}</span>
                  <strong>{purchase.amount.toFixed(2)} SEK</strong>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="dashboard-card">
        <h3>Bokningar</h3>
        {bookings.length === 0 ? <p>Inga bokningar ännu.</p> : (
          <div className="dashboard-history-list">
            {bookings.slice(0, 8).map(booking => (
              <div key={booking.id} className="dashboard-history-item">
                <div>
                  <strong>{booking.date}</strong>
                  <p>{booking.startTime} - {booking.endTime}</p>
                </div>
                <div className="dashboard-history-meta">
                  <span>{booking.status}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
